import styled from 'styled-components';
import { token } from '@bynder/design-system';

export const TextMuted = styled.span`
    color: ${token.colorTextMuted};
`;
